
import { useDispatch, useSelector } from "react-redux";
import "./Search.css";
import axios from "axios";
import { baseUrl } from "../Constants";
import { useEffect, useState } from "react";
import moment from "moment/moment";
import ClearIcon from '@mui/icons-material/Clear';
import { onChange } from "./Redux/SearchSlice";
import { CubicBoxData } from "./AcademiesFolder/CubicBoxData";
import { ClientAcademiesTabData } from "./AcademiesFolder/ClientAcademiesTabData";
import ExplorebyTopic from "./AIAcademyFolder/ExplorebyTopic.json";
import {ExplorebyProgramData} from "./AIAcademyFolder/ExplorebyProgramData";
import { DataAiCertificationsData } from "./ProgramsFolder/DataAiCertificationsData";
import DataExploreProgram from "../data/ExploreBy&Program&Certificate.json"
export const Search = () => {
    const [data, setData] = useState([])
    const dispatch = useDispatch()
    const select = useSelector(state => state.search.value)
    const [searchRecords,setSearchRecords] = useState(20)

    const searchResult = async () => {
        
        const body = { keyword: select }
        const CubicBox = CubicBoxData && CubicBoxData.filter((i)=>(i.title.toLowerCase().includes(select.toLowerCase()) || i.para.toLowerCase().includes(select.toLowerCase())) );
        const ClientAcademies = ClientAcademiesTabData && ClientAcademiesTabData.filter((i)=>(i.title.toLowerCase().includes(select.toLowerCase()) || i.portal_content.toLowerCase().includes(select.toLowerCase())))
        const Explore = ExplorebyTopic && ExplorebyTopic.courses.filter((i)=>(i.category.toLowerCase().includes(select.toLowerCase())
         || i.title.toLowerCase().includes(select.toLowerCase()) || i.subcategory.toLowerCase().includes(select.toLowerCase())) );
        const ExplorebyRoles = ExplorebyProgramData && ExplorebyProgramData.filter((i)=>(i.title.toLowerCase().includes(select.toLowerCase()) ))
        const DataAiCertifications = DataAiCertificationsData && DataAiCertificationsData.filter((i)=>(i.title.toLowerCase().includes(select.toLowerCase()) ))
        const DataExplore = DataExploreProgram.DataExploreProgram && DataExploreProgram?.DataExploreProgram?.filter((i)=>i.Head.toLowerCase().includes(select.toLowerCase()))
        const Programs = DataExploreProgram.Programs && DataExploreProgram?.Programs?.filter((i)=>i.Head.toLowerCase().includes(select.toLowerCase()))

        const response = await axios.put(`${baseUrl}/search`, body, {
            headers: {
                Authorization: localStorage.getItem("token"),
            }
        }).then(res=>{
            setData([...res.data.data,...CubicBox,...ClientAcademies,...Explore,...ExplorebyRoles,...DataAiCertifications,...DataExplore,...Programs])
            setSearchRecords(20)
            
        })
        
    }
    useEffect(() => {
        searchResult()
    }, [select]);
    const onMouseClick = () =>{
          dispatch(onChange())
    }

    return (
        <div className="ui-container-search">
            <div style={{ padding: '8em 5em'}}>
                <div style={{display:'flex',justifyContent:'space-between'}}>
                <p className="para-head">
                    Result for " {select} "
                </p>
                <p><ClearIcon style={{ cursor: 'pointer', color: "grey",fontSize:'2em' }}
                 onClick={()=>onMouseClick()} /></p>

                {/* <p><b>Filter results by:</b></p> */}
                </div>

            {console.log("data9",data,CubicBoxData,ClientAcademiesTabData)}
                {data && data.map((item,index) => {
                    if(index < searchRecords){
                    return (
                        <div className="content-search">
                            {item.CourseName &&<a className="link-search"  target="_blank" href={item.WorkdaySessionLink} >{item.CourseName}</a>}
                            {item.title && <a className="link-search" href={item.url} target="_blank">{item.title}</a>}
                            <p className="search-details">{item.category && item.category !=="" ?<span>Category:{item.category}</span>:null}{item.subcategory && item.subcategory !=="" ?<span> ,SubCategory:{item.subcategory}</span>:null} {item.duration && item.duration !=="" ?<span> ,Duration: {item.duration}</span>:null}{item.type && item.type !=="" ?<span>Type:{item.type}</span>:null}</p>
                            

                            <p className="search-details">{item.SessionStartDate && item.SessionStartDate !==""?<span>StartDate: {moment(item.SessionStartDate).format("DD MMM YYYY")}</span>:null} {item.SessionEndDate && item.SessionEndDate !=="" ?<span>,EndDate: {moment(item.SessionEndDate).format("DD MMM YYYY")}</span>:null}{item.Category && item.Category !=="" ?<span>,Category:{item.Category}</span>:null}{item.Capability && item.Capability !=="" ?<span>,Capability:{item.Capability}</span>:null}{item.ModeOfDelivery && item.ModeOfDelivery !==""?(<span>,ModeOfDelivery:{item.ModeOfDelivery}</span>):null} {item.TargetAudienceLevel && item.TargetAudienceLevel!==""?(<span>,Target Audience:{item.TargetAudienceLevel}</span>):null}</p>
                            {item.Traininghost ?<p className="text-search">Hosted By: <a href={`mailto:${item.Traininghost}@accenture.com`} >{`${item.Traininghost}@accenture.com`}</a></p>:null}
                            {item.short_des && <p className="text-search">{item.short_des}</p>}
                            {item.description && <p className="text-search">{item.description}</p>}
                            {item.list_0 && <p className="sm-space">{item.list_0}</p>}{ item.list_1 && <p className="sm-space">{item.list_1}</p> }{item.list_2 && <p className="sm-space">{item.list_2}</p>}{item.list_3 && <p className="sm-space">{item.list_3}</p>}
                             
                            {item.para && <p className="sm-space">{item.para}</p>}
                            {item.portal_content && <p className="sm-space">{item.portal_content}</p>}
                            {item.portal_content_points && <a className="link-search"  target="_blank">
                                <div dangerouslySetInnerHTML={{ __html: item.portal_content_points[0] }} />
                            </a>}

                            {item.portal_content_points && item.portal_url && <a className="link-search learn-more"
                             href={item.portal_url}  target="_blank">Learn more ...</a>}
                            {item.items && item.items.length > 0 &&
                            <div style={{display:'grid',gridTemplateColumns:"auto", justifyContent:'space-between'}}>
                             {item.items.map((it)=>(
                                <a style={{width:'14em'}} className="sm-space" href={it.url} target="_blank">{it.name}</a>
                            ))}
                            </div>
                            }
                             {item.lists && <p style={{fontSize:'0.9em'}}><a className="link-search"  target="_blank">
                                <div dangerouslySetInnerHTML={{ __html: item.lists[0] }} />
                                </a>
                            </p>}
                            {item.Head && item.level1 || item.level2 ? <div>
                                 <p className="link-search">{item.Head}</p>
                                 {item.level1 && <p><a className="sm-space" href={item.level1URL} target="_blank">{item.level1}</a></p>}
                                 {item.level2 &&  <p><a className="sm-space" href={item.level2URL} target="_blank">{item.level2}</a></p> }
                                 {item.level3 && <p><a className="sm-space" href={item.level3URL} target="_blank">{item.level3}</a></p> }
                                 {item.level4 &&  <p><a className="sm-space" href={item.level4URL} target="_blank">{item.level4}</a></p> }
                                 {item.level5 && <p><a className="sm-space" href={item.level5URL} target="_blank">{item.level5}</a></p> }

                                 </div>:null
                            }


                            {item.Head && item.PowerArenas && 
                            <div>
                                <p className="link-search">{item.Head}</p>
                                {item.PowerArenas.map((i)=>(
                                    <>
                                    <p><a className="sm-space" href={i.Link1URL} target="_blank">{i.Link1}</a></p>
                                    <p><a className="sm-space" href={i.Link2URL} target="_blank">{i.Link2}</a></p>
                                    <p><a className="sm-space" href={i.Link3URL} target="_blank">{i.Link3}</a></p>

                                    </>
                                ))}
                            </div> }
                            
                            {item.Head && item.URL &&  <a className="link-search" href={item.URL} target="_blank">{item.Head}</a>}

                                                {item.know_more_url &&  <a
                                                href={item.know_more_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{marginTop:'0.5em'}}
                                            >
                                                <button className="lc_register_sec">Register Now</button>
                                            </a>}
                                              {item.explore_0 &&  <a
                                                href={item.explore_0}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{marginTop:'0.5em'}}
                                            >
                                                <button className="lc_register_sec">Register Now</button>
                                            </a>}
                        </div>
                    )}
                })}
                {data && data.length >20 && data.length >searchRecords &&<div style={{display:'flex', justifyContent:'center'}}>
                    <button  className="load-more" onClick={()=>setSearchRecords(searchRecords + 20 )}>Load More</button>
                </div>}
                {/* <div className="content-search">
                    <a className="link-search" href="https://wd103.myworkday.com/accenture/learning/course/e53b3245140f1002a4471c3f32d60001?type=9882927d138b100019b928e75843018d" >Course Inside Agentic AI: Popular Frameworks</a>
                    <p>Jun 2, 2025</p>
                    <p className="text-search">Intended Audience: All Data & AI and Cloud First Practitioners in Americas (By Invite Only) Duration: 1.5 hours Time & Expense: $5 tuition will be billed to your cost center. Time can be charged to the Central training WBS Given the fast</p>
                </div> */}
            </div>
        </div>
    )
}